import {HttpBackend, HttpClient} from '@angular/common/http';
import {inject, Provider} from '@angular/core';
import {CanMatchFn} from '@angular/router';
import {CONNECT_INTEGRATIONS_TRANSPORT, ConnectIntegrationsService} from '../../../services/connect/connect-integrations.service';

export function isLocalIntegrationUrl(href: string): boolean {
    try {
        const url = new URL(href);
        return ['http:', 'https:'].includes(url.protocol)
            && ['localhost', '127.0.0.1', '[::1]'].includes(url.hostname)
            && !url.username && !url.password
            && url.pathname === '/connect/local/integrations'
            && url.searchParams.getAll('localIntegration').length === 1
            && url.searchParams.get('localIntegration') === '1';
    } catch {
        return false;
    }
}

export const connectIntegrationsLocalCanMatch: CanMatchFn = () =>
    typeof window !== 'undefined' && isLocalIntegrationUrl(window.location.href);

export const connectIntegrationsLocalProviders: Provider[] = [
    ConnectIntegrationsService,
    {
        provide: CONNECT_INTEGRATIONS_TRANSPORT,
        useFactory: () => {
            if (typeof window === 'undefined' || !isLocalIntegrationUrl(window.location.href)) {
                throw new Error('Local integration transport requires an explicit loopback route.');
            }
            // This route talks to the real local API through the development proxy.
            return new HttpClient(inject(HttpBackend));
        },
    },
];
